import type { AnchorHTMLAttributes, ReactNode } from "react";
import { IUBENDA_PREFERENCES_LINK_CLASS } from "@/constants/iubenda";

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  children: ReactNode;
};

export function IubendaCookiePreferencesLink({ children, className, ...rest }: Props) {
  return (
    <a
      href="#"
      className={[IUBENDA_PREFERENCES_LINK_CLASS, className].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </a>
  );
}
